import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { mobileFooterTabs } from "../../../utils/constants/mobileFooter.constants";
import { DashboardGameTabsEnum, setEventType, SPORTS_MAP, useAppDispatch, useAppSelector } from "@hypexone/uicore";
import { isIOS, isMobile } from "react-device-detect";
import YuviGames from "../YuviGames/YuviGames";

const MobileFooter: React.FC = () => {
  const [navLinkWidth, setNavLinkWidth] = useState<number | null>(null);
  const navLinkRef = useRef<HTMLAnchorElement>(null);
  const dispatch = useAppDispatch();
  
  useEffect(() => {
    // Function to calculate the width of the first NavLink
    const calculateNavLinkWidth = () => {
      if (navLinkRef.current) {
        setNavLinkWidth(navLinkRef.current.offsetWidth);
      }
    };

    // Calculate on component mount
    calculateNavLinkWidth();

    // Optional: Adjust on window resize if needed
    window.addEventListener("resize", calculateNavLinkWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", calculateNavLinkWidth);
    };
  }, []);

  const leftPosition = navLinkWidth ? navLinkWidth * 2 : 0;
  const {langData} = useAppSelector((state) => state.cms);

  return (
    <>
      {/* <div
        style={{
          width: `90px`,
          transform: "translateZ(0)",
          height: "80px",
        }}
        className="fixed bg-blue4 rounded-t-full bottom-0 w-full z-10 left-[-5px]"
      /> */}

      <div
        className={`grid grid-cols-5 items-center fixed bottom-0 w-full bg-mobile-footer-background-color z-20 h-[60px]`} // Fixed positioning and z-index to ensure it stays at the bottom
      >
        {/* <div className="flex justify-center items-center relative top-[-10px] left-1">
          {(isMobile || isIOS) ? <YuviGames /> : null}
        </div> */}

        {mobileFooterTabs.map((footer, index) => {
          const isHomeTab = footer.title === "Home";
          const isAccountTab = footer.title === "Account"; 
          const linkProps = isAccountTab
            ? { to: "/mobile-menu" }
            : { to: footer.navigationUrl }; 

          return (
            <NavLink
              {...linkProps}
              key={footer.title + index}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center h-full ${isActive
                  ? "bg-selected-mobile-footer-custom-gradient"
                  : ""}
                `
              }
              onClick={() => {
                if (footer.title === "Sports") {
                  dispatch(setEventType(SPORTS_MAP.get(DashboardGameTabsEnum.CRICKET)));
                }
              }}
              ref={index === 0 ? navLinkRef : null} // Only set ref for the first NavLink as width of all navLinks will be same as its grid
            >
              <footer.imageSrc className="h-[24px] w-[24px] text-white" />
              <div className="text-white text-xs text-center">{footer.title}</div>
            </NavLink>
          );
        })}
      </div>
    </>
  );
};

export default MobileFooter;
